module.exports = __webpack_public_path__ + "static/media/21_pol_0_84.54.c31ebee1.png";